import React, { FC, useState } from "react";
import {
  Main,
  Logo,
  Container,
  Title,
  CheckboxWrapper,
  ModalHyperlink,
} from "./elements";
import logo from "../../../assets/images/new_logo_dark.svg";
import { ApplicantDetailsButton } from "../../organisms/ApplicantDetailsButton";
import { ApplicantDetailsStepper } from "../../organisms/ApplicantDetailsStepper";
import { Props } from "./types";
import { Checkbox } from "../../atoms/Checkbox";
import { Modal } from "../../organisms/Modal";

const ApplicantForm: FC<Props> = props => {
  const { current, modalTitle, modalBody, isLoading } = props;

  const [modalVisible, setModalVisible] = useState(false);
  const [acceptInformation, setAcceptInformation] = useState(false);

  return (
    <Main>
      <Logo src={logo} alt="logo" />
      <Container>
        <Title>
          {current === 0 && "Let's get to know you"}
          {current === 1 && "Tell us what you got."}
          {current === 2 && "How can we contact you?"}
          {current === 3 && "You're almost there!"}
        </Title>
        <ApplicantDetailsStepper {...props} />
        {current === 3 && (
          <>
            <CheckboxWrapper>
              <Checkbox
                checked={acceptInformation}
                onChange={e => setAcceptInformation(e.target.checked)}
              >
                I have read, understand, and accept this{" "}
                <ModalHyperlink onClick={() => setModalVisible(true)}>
                  information
                </ModalHyperlink>
                .
              </Checkbox>
            </CheckboxWrapper>
            <Modal
              visible={modalVisible}
              onModalClose={() => setModalVisible(false)}
              title={modalTitle}
              body={modalBody}
            />
          </>
        )}
        <ApplicantDetailsButton
          {...props}
          buttonLoading={isLoading}
          acceptInformation={acceptInformation}
        />
      </Container>
    </Main>
  );
};

export default ApplicantForm;
